<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M12.28 14.788H2.254V2.253h5.014v4.074c0 .261.091.483.274.666a.907.907 0 0 0 .666.274h4.074zM8.52 2.332c.19.065.324.137.402.215l3.065 3.065c.078.079.15.212.215.402H8.521zm4.818 3.133a2.276 2.276 0 0 0-.47-.744L9.813 1.666a2.282 2.282 0 0 0-.744-.47A2.26 2.26 0 0 0 8.207 1H1.94a.906.906 0 0 0-.666.274A.906.906 0 0 0 1 1.94v13.161c0 .261.091.483.274.666a.907.907 0 0 0 .666.274h10.654a.907.907 0 0 0 .666-.274.907.907 0 0 0 .274-.666V6.327a2.26 2.26 0 0 0-.196-.862z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M12.28 14.788H2.254V2.253h5.014v4.074c0 .261.091.483.274.666a.907.907 0 0 0 .666.274h4.074zM8.52 2.332c.19.065.324.137.402.215l3.065 3.065c.078.079.15.212.215.402H8.521zm4.818 3.133a2.276 2.276 0 0 0-.47-.744L9.813 1.666a2.282 2.282 0 0 0-.744-.47A2.26 2.26 0 0 0 8.207 1H1.94a.906.906 0 0 0-.666.274A.906.906 0 0 0 1 1.94v13.161c0 .261.091.483.274.666a.907.907 0 0 0 .666.274h10.654a.907.907 0 0 0 .666-.274.907.907 0 0 0 .274-.666V6.327a2.26 2.26 0 0 0-.196-.862z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B2A8C1',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>
